import React, { useContext } from 'react'
import { getDaysByWeek, getWeekdays } from '../helpers'
import { CalendarContainer, DayTypography, GridContainer } from './Calendar.styles'
import { DatePickerContext } from '../DatePickerProvider'
import Month from './Month'
import Day from './Day'
import { Box, capitalize } from '@mui/material'

export const Calendar = ({ ...props }) => {
  const { referenceDay, locale } = useContext(DatePickerContext)
  const daysByWeek = getDaysByWeek(referenceDay, locale)

  return (
    <CalendarContainer {...props}>
      <Month />
      <GridContainer>
        {getWeekdays(locale).map((day) => (
          <Box key={day}>
            <DayTypography>{capitalize(day)}</DayTypography>
          </Box>
        ))}
        {daysByWeek.map((week) =>
          week.map((day, index) => (
            <Day
              key={day.toLocaleDateString()}
              day={day}
              isendofweek={index === 6 ? 1 : 0}
              isstartofweek={index === 0 ? 1 : 0}
            />
          )),
        )}
      </GridContainer>
    </CalendarContainer>
  )
}
